module.exports = __webpack_public_path__ + "static/fonts/SanFranciscoDisplayThin.9d1a7c9.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/SanFranciscoDisplayThin.ttf
// module id = ls5Y
// module chunks = 1